var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('label-form',{attrs:{"loading":_vm.loading,"contact":_vm.contact,"property":_vm.property,"labelData":_vm.label,"formErrors":_vm.formErrors},on:{"labelSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }